export const CONTROLS_LAYER = 30;
export const HIGHLIGHTED_EDGE = 100;
export const CONDITION_ARROW_TRAIL = 3;
